var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubmodel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.69514 3.98663C3.44358 6.10184 1.69306 13.7604 5.55879 17.6261L7.60106 19.5954L9.86215 17.4802C11.1021 16.2403 12.415 14.5627 12.7797 13.6145C13.2173 12.5204 13.9467 12.0098 14.6761 12.1557C16.4266 12.5204 16.7913 14.8544 15.1137 15.4379C13.1444 16.0944 10.5186 18.6472 10.5186 19.8872C10.5186 21.7106 15.6243 20.3977 18.1771 17.8449C20.0006 15.9485 20.3653 15.0732 20.3653 12.0098C20.3653 9.09231 20.0006 7.99823 18.4689 6.53947L16.5725 4.64307L14.2384 6.61241C12.9256 7.70648 11.5397 9.38406 11.175 10.3323C10.7374 11.4993 10.081 12.0098 9.27864 11.864C7.52813 11.4993 7.16343 9.16524 8.84101 8.65468C10.7374 7.92529 14.1655 4.64307 13.7279 3.84075C13.2902 3.11137 10.6645 3.18431 8.69514 3.98663Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmodel);
export default __webpack_public_path__ + "static/media/submodel.a6d9dc84a27ac4ff3763fa2d98476a9c.svg";
export { ForwardRef as ReactComponent };